<template>
  <v-container class="px-2 pb-2" fluid>
    <v-text-field
      v-model="searchText"
      dense
      chips
      color="blue-grey lighten-2"
      label="Search"
      item-text="name"
      item-value="name"
      multiple
      class="px-4 pb-2"
    >
     <!-- :items="headerItems" -->
      <!-- <template v-slot:selection="data">
        <v-chip
          :input-value="data.selected"
          close
          class="chip--select-multi caption"
          @click:close="remove(data.item)"
        >
          {{ data.item.name }}
        </v-chip>
      </template>
      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-item-content v-text="data.item" class="caption"></v-list-item-content>
        </template>
        <template v-else> -->
          <!-- <v-list-tile-avatar>
            <img :src="data.item.avatar">
          </v-list-tile-avatar> -->
          <!-- <v-list-item-content>
            <v-list-item-title v-html="data.item.name" class="caption"></v-list-item-title>
            <v-list-item-subtitle v-html="data.item.group" class="caption"></v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template> -->
    </v-text-field>
    <v-layout row wrap class="px-2 pb-2">
        <v-flex v-for="(item, i) in filteredData" :key="item.title" xs12 md3 pl-5 pr-5 pt-5>
          <v-card
            tile
            outlined
            id="header-size"
            @click="cardClick(item)"
            class="mx-auto elevation-1 mb-2"
            :ripple="{ class: 'white--text', center: true }">
          <v-list dense>
            <v-list-item-content>
              <v-icon :color="colors[i]" size="36"  class="pr-2">{{icons[i]}}</v-icon>
              <v-list-item-subtitle class="text-center text-size-title font-bold mt-2" >
                {{item.fullname}}
              </v-list-item-subtitle>
              <v-list-item class="pb-0 mb-0 dense">
                <v-divider class=""></v-divider>
              </v-list-item>
              <v-list-item-subtitle class="text-left pl-6 font-bold text-size mt-1 ">
                Reports Description
              </v-list-item-subtitle>
              <v-list-item class="pb-0 mb-0 mt-0 px-2 dense">
                <v-card-subtitle v-if="item.description == null || item.description.trim() == '' || item.description.trim().length == 0" style="font-size: 0.7rem;">The category description is not available.</v-card-subtitle>
                <v-card-subtitle v-else style="font-size: 0.7rem;">{{item.description}}</v-card-subtitle>
              </v-list-item>
              <v-list-item-content style="position: absolute; bottom: 16px; width:100%;">
                <v-list-item class="pb-0 mb-0 dense" >
                  <v-divider class="" style="background: white;" ></v-divider>
                </v-list-item>
                <v-list-item class="pb-0 mb-0 dense" >
                  <!-- <v-chip tile color="#339966" dark class="ml-4" style="font-size: 0.72rem; border-radius: 0%;" label>See the {{item.count}} Reports</v-chip> -->
                  <v-flex>
                    <v-btn tile small class="px-sm-4 text-none" color="#339966" dark style="font-size: 0.6rem; font-weight: normal;" > See the {{item.count}} Reports</v-btn>
                  </v-flex>
                </v-list-item>
              </v-list-item-content>
            </v-list-item-content>
          </v-list>
          </v-card>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'App',
  props: {
    source: String
  },
  computed: {
    ...mapState([
      'partners'
    ])
  },
  watch: {
    searchText: function (newVal, oldVal) {
      console.log(oldVal);
      // loop through the data and apply the filter
      this.filteredData = []
      for (let i = 0; i < this.headerItems.length; i++) {
        const data = this.headerItems[i]
        const name = JSON.stringify(data)

        // filter the data
        if ((name.toString().toLowerCase()).includes(newVal.toString().toLowerCase())) {
          this.filteredData.push(data)
        }
        console.log('looping', name)
      }
    },
  },
  data: () => {
    return {
      searchText: '',
      filteredData: [],
      categories: null,
      icons: ['mdi-abacus', 'mdi-google-analytics', 'mdi-chart-box-multiple-outline', 'mdi-finance', 'mdi-chart-gantt', 'mdi-chart-multiple', 'mdi-math-norm', 'mdi-chart-scatter-plot', 'mdi-poll', 'mdi-approximately-equal-box', 'mdi-sign-text', 'mdi-chart-box', 'mdi-chart-arc'],
      colors: ['#44a04c', '#e73827', '#44a04c', '#e73827', '#44a04c', '#c5796d', '#44a04c', '#e73827', '#44a04c', '#44a04c', '#e58494', '#44a04c', '#e73827', '#44a04c'],
      oneCard: false,
      twoCards: false,
      moreThanTwoCards: false,
      headerItems: []
    }
  },
  mounted: [
    function () {
      window.axios.get('reportCategory/findPublicReportCount')
        .then((response) => {
          var dataSize = response.data.length
          this.headerItems = response.data
          this.filteredData = response.data

          if (dataSize === 1) {
            this.oneCard = true
          } else if (dataSize === 2) {
            this.twoCards = true
          } else {
            this.moreThanTwoCards = true
          }
          // use these categories to get their views and the number of HIS partners viewing them
        }).catch(() => {
          return 'unavailable'
        })
    }
  ],
  methods: {
    remove (item) {
      const index = this.categories.indexOf(item.name)
      if (index >= 0) this.categories.splice(index, 1)
    },
    cardClick (item) {
      if (item.count !== 0) {
        localStorage.setItem('cData', item.name)
        var route = '/publicCardReports'
        this.$router.push(route).catch(() => {
          window.location.reload()
        })
      }
    },
    // getReportDetails () {
    // }
  }
}
</script>
<style scoped>
.text-size {
  font-size: 0.84em;
  font-weight: 420;
  color: #595959;
}

.text-size-title {
  font-size: 0.86em;
  font-weight: 430;
  color: #595959;
}
.v-text-field >>> input {
  font-size: 0.84em;
}
.v-text-field >>> label {
  font-size: 0.84em;
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (max-width: 1600px) {
  #header-size{
    height: 500px;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1600px) {
  #header-size{
    height: 500px;
  }
}
</style>
